import type { FormValidationTranslationsObject } from "../../translation-keys/form-validation-keys.js";

const FormValidation: FormValidationTranslationsObject = {
  eclipse_FirstName_Error: "Geben Sie bitte Ihren Vornamen an",
  eclipse_LastName_Error: "Geben Sie bitte Ihren Nachnamen an",
  eclipse_Email_Error: "Geben Sie bitte Ihre E-Mail-Adresse an",
  eclipse_Company_Error: "Geben Sie bitte Ihr Unternehmen an",
  eclipse_Country_Error: "Geben Sie bitte Ihren Land an",
  eclipse_State_Error: "Dieses Feld ist ein Pflichtfeld.",
  eclipse_Phone_Error: "Geben Sie bitte Ihre Telefonnummer an",
  eclipse_Tier__c_Error: "Geben Sie bitte die Größe Ihres Unternehmens an",
  eclipse_Industry_Error: "Geben Sie bitte Ihre Branche an",
  eclipse_Department__c_Error: "Geben Sie bitte Ihre Abteilung an",
  eclipse_Email_Opt_In__c_Error: "Dieses Feld ist ein Pflichtfeld.",
  eclipse_contactRequested_Error: "", // Not currently Used
  eclipse_Webform_Comments_recent_value__c_Error: "", //need this info
  eclipse_Latest_Solution_Interest__c_Error: "Dieses Feld ist ein Pflichtfeld.",
  eclipse_Entity_Error: "Please enter the Legal Entity Name",
  eclipse_NonBusinessEmail_Error: "Geben Sie bitte Ihre E-Mail-Adresse an",
  eclipse_Partner_Opt_in_Processing__c_Error: "",
};

export default FormValidation;
